"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DataUpload extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dataUpload';
        this._file = initParams.file;
        this._groupName = initParams.group_name;
        this._noHeaders = (0, util_1.camelArray)(initParams.no_headers);
        this._columnData = (0, util_1.camelArray)(initParams.column_data);
        this._csvFileNames = (0, util_1.camelArray)(initParams.csv_file_names);
        this._uploaded = initParams.uploaded;
        this._dataItemsLayout = initParams.data_items_layout;
        this._dataItemsColumn = initParams.data_items_column;
        this._dataItems = (0, util_1.camelArray)(initParams.data_items);
        this._newDevices = (0, util_1.camelArray)(initParams.new_devices);
        this._newSites = (0, util_1.camelArray)(initParams.new_sites);
        this._dataTypes = (0, util_1.camelArray)(initParams.data_types);
        this._previewSampleData = initParams.preview_sample_data;
        this._processedErrors = initParams.processed_errors;
        this._processingStatusDetails = initParams.processing_status_details;
        this._uploadingStatusDetails = initParams.uploading_status_details;
        this._status = initParams.status;
    }
    set file(value) {
        console.error('Do not set objects this way');
    }
    setFile(value) {
        return this.dataService.updateDataUpload(this.id, { file: value }, this);
    }
    get file() {
        return this._file;
    }
    set groupName(value) {
        console.error('Do not set objects this way');
    }
    setGroupName(value) {
        return this.dataService.updateDataUpload(this.id, { group_name: value }, this);
    }
    get groupName() {
        return this._groupName;
    }
    set noHeaders(value) {
        console.error('Do not set objects this way');
    }
    setNoHeaders(value) {
        return this.dataService.updateDataUpload(this.id, { no_headers: (0, util_1.snakeArray)(value) }, this);
    }
    get noHeaders() {
        return this._noHeaders;
    }
    set columnData(value) {
        console.error('Do not set objects this way');
    }
    setColumnData(value) {
        return this.dataService.updateDataUpload(this.id, { column_data: (0, util_1.snakeArray)(value) }, this);
    }
    get columnData() {
        return this._columnData;
    }
    set csvFileNames(value) {
        console.error('Do not set objects this way');
    }
    setCsvFileNames(value) {
        return this.dataService.updateDataUpload(this.id, { csv_file_names: (0, util_1.snakeArray)(value) }, this);
    }
    get csvFileNames() {
        return this._csvFileNames;
    }
    set uploaded(value) {
        console.error('Do not set objects this way');
    }
    setUploaded(value) {
        return this.dataService.updateDataUpload(this.id, { uploaded: value }, this);
    }
    get uploaded() {
        return this._uploaded;
    }
    set dataItemsLayout(value) {
        console.error('Do not set objects this way');
    }
    setDataItemsLayout(value) {
        return this.dataService.updateDataUpload(this.id, { data_items_layout: value }, this);
    }
    get dataItemsLayout() {
        return this._dataItemsLayout;
    }
    set dataItemsColumn(value) {
        console.error('Do not set objects this way');
    }
    setDataItemsColumn(value) {
        return this.dataService.updateDataUpload(this.id, { data_items_column: value }, this);
    }
    get dataItemsColumn() {
        return this._dataItemsColumn;
    }
    set dataItems(value) {
        console.error('Do not set objects this way');
    }
    setDataItems(value) {
        return this.dataService.updateDataUpload(this.id, { data_items: (0, util_1.snakeArray)(value) }, this);
    }
    get dataItems() {
        return this._dataItems;
    }
    set newDevices(value) {
        console.error('Do not set objects this way');
    }
    setNewDevices(value) {
        return this.dataService.updateDataUpload(this.id, { new_devices: (0, util_1.snakeArray)(value) }, this);
    }
    get newDevices() {
        return this._newDevices;
    }
    set newSites(value) {
        console.error('Do not set objects this way');
    }
    setNewSites(value) {
        return this.dataService.updateDataUpload(this.id, { new_sites: (0, util_1.snakeArray)(value) }, this);
    }
    get newSites() {
        return this._newSites;
    }
    set dataTypes(value) {
        console.error('Do not set objects this way');
    }
    setDataTypes(value) {
        return this.dataService.updateDataUpload(this.id, { data_types: (0, util_1.snakeArray)(value) }, this);
    }
    get dataTypes() {
        return this._dataTypes;
    }
    set previewSampleData(value) {
        console.error('Do not set objects this way');
    }
    setPreviewSampleData(value) {
        return this.dataService.updateDataUpload(this.id, { preview_sample_data: value }, this);
    }
    get previewSampleData() {
        return this._previewSampleData;
    }
    set processedErrors(value) {
        console.error('Do not set objects this way');
    }
    setProcessedErrors(value) {
        return this.dataService.updateDataUpload(this.id, { processed_errors: value }, this);
    }
    get processedErrors() {
        return this._processedErrors;
    }
    set processingStatusDetails(value) {
        console.error('Do not set objects this way');
    }
    setProcessingStatusDetails(value) {
        return this.dataService.updateDataUpload(this.id, { processing_status_details: value }, this);
    }
    get processingStatusDetails() {
        return this._processingStatusDetails;
    }
    set uploadingStatusDetails(value) {
        console.error('Do not set objects this way');
    }
    setUploadingStatusDetails(value) {
        return this.dataService.updateDataUpload(this.id, { uploading_status_details: value }, this);
    }
    get uploadingStatusDetails() {
        return this._uploadingStatusDetails;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    setStatus(value) {
        return this.dataService.updateDataUpload(this.id, { status: value }, this);
    }
    get status() {
        return this._status;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateDataUpload(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteDataUpload(this.id, this);
    }
}
exports.default = DataUpload;
//# sourceMappingURL=dataUpload.js.map